import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"row-12 text-end\"><button class=\"btn btn-primary btn-sm\" data-bs-toggle=\"modal\" data-bs-target=\"#modal_upload_merchant_file\"><span class=\"svg-icon svg-icon-2\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\"><path opacity=\"0.3\" d=\"M10 4H21C21.6 4 22 4.4 22 5V7H10V4Z\" fill=\"currentColor\"></path><path d=\"M10.4 3.60001L12 6H21C21.6 6 22 6.4 22 7V19C22 19.6 21.6 20 21 20H3C2.4 20 2 19.6 2 19V4C2 3.4 2.4 3 3 3H9.20001C9.70001 3 10.2 3.20001 10.4 3.60001ZM16 11.6L12.7 8.29999C12.3 7.89999 11.7 7.89999 11.3 8.29999L8 11.6H11V17C11 17.6 11.4 18 12 18C12.6 18 13 17.6 13 17V11.6H16Z\" fill=\"currentColor\"></path><path opacity=\"0.3\" d=\"M11 11.6V17C11 17.6 11.4 18 12 18C12.6 18 13 17.6 13 17V11.6H11Z\" fill=\"currentColor\"></path></svg></span>Upload Files </button></div>", 1)
const _hoisted_2 = { class: "card card-flush mt-5" }
const _hoisted_3 = { class: "card-body table align-middle table-row-dashed fs-7 gy-1 dataTable no-footer pt-0 pb-0" }
const _hoisted_4 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "svg-icon svg-icon-2x svg-icon-primary me-4" }
const _hoisted_7 = { class: "d-flex justify-content-end" }
const _hoisted_8 = {
  class: "ms-2",
  "data-kt-filemanger-table": "copy_link"
}
const _hoisted_9 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-light btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end"
}
const _hoisted_10 = { class: "svg-icon svg-icon-5 m-0" }
const _hoisted_11 = {
  class: "menu menu-sub align-items-center menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-4 w-600px",
  "data-kt-menu": "true"
}
const _hoisted_12 = { class: "card card-flush" }
const _hoisted_13 = { class: "card-body p-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadMerchantFileModal = _resolveComponent("UploadMerchantFileModal")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_UploadMerchantFileModal),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Datatable, {
          "table-data": _ctx.tableData,
          "table-header": _ctx.tableHeader,
          "enable-items-per-page-dropdown": true,
          onCurrentChange: _ctx.onCurrentChange,
          onSort: _ctx.onSort,
          onItemsPerPageChange: _ctx.onItemsPerPageChange,
          loading: _ctx.loading,
          rowsPerPage: _ctx.pagination.rowsPerPage
        }, {
          "cell-checkbox": _withCtx(({ row: files }) => [
            _createElementVNode("div", _hoisted_4, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                value: files.id,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.checkedFiles) = $event))
              }, null, 8, _hoisted_5), [
                [_vModelCheckbox, _ctx.checkedFiles]
              ])
            ])
          ]),
          "cell-name": _withCtx(({ row: files }) => [
            _createElementVNode("span", _hoisted_6, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/files/fil004.svg" })
            ]),
            _createTextVNode(" " + _toDisplayString(files.name), 1)
          ]),
          "cell-folder": _withCtx(({ row: files }) => [
            _createTextVNode(_toDisplayString(files.folder), 1)
          ]),
          "cell-size": _withCtx(({ row: files }) => [
            _createTextVNode(_toDisplayString(files.size) + " KB ", 1)
          ]),
          "cell-last_modified": _withCtx(({ row: files }) => [
            _createTextVNode(_toDisplayString(files.last_modified), 1)
          ]),
          "cell-actions": _withCtx(({ row: files }) => [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, [
                    _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen052.svg" })
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(files.url), 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["table-data", "table-header", "onCurrentChange", "onSort", "onItemsPerPageChange", "loading", "rowsPerPage"])
      ])
    ])
  ], 64))
}